// extracted by mini-css-extract-plugin
export var errorIcon = "_jr-1";
export var nameLogo = "_jr-0";